import $ from 'jquery';
import { MQ } from '../tools/MQ.js';

export const init = ($target) => {
	const jsLink = $('.js-menu-link'),
		jsControl = $('.js-menu-control'),
		jsMenu = $('.js-menu-mega'),
		jsBack = $('.js-menu-back'),
		$body = $('body'),
		CONTENT_CLASS = '.js-footer-content',
		MENU_CLASS = '.js-menu-mega';

	function toggleContent(event) {
		if (MQ('lgDown')) {
			event.preventDefault();
			$(this).hide();
			$(this).next(MENU_CLASS).slideDown();
			$(this).next(MENU_CLASS).find('.nav-mega__name').css('opacity', '1');
		}
	}

	function toggleMenu() {
		$body.toggleClass('menu-open');
	}

	function onResize() {
		if (!MQ('lgUp')) {
			return;
		}
		$('.js-menu-link').removeAttr('style');
		$('.js-menu-mega').removeAttr('style');
	}

	function backMenu() {
		$(this).parents(MENU_CLASS).slideUp();
		$(this).parents(MENU_CLASS).prev().slideDown();
		$(this).parent().css('opacity', '0');
	}

	$(jsLink).on('click', toggleContent);
	$(jsControl).on('click', toggleMenu);
	$(jsBack).on('click', backMenu);
	$(window).on('resize', onResize);
};
